import { useSearchParams } from "react-router"
import { getInsensitiveSearchParams } from "@/lib/get-insensitive-search-params"

export const usePreviewParam = () => {
  const [searchParams] = useSearchParams()
  return getInsensitiveSearchParams(searchParams, "preview").exists
}
